import { fn_search_tpay_fee, fn_tpay_request } from "../http/dlvTpayConn";
import { fn_deliveryFeeFail } from "./FnBodyLayer";
import { select_access_token } from "../http/TokenConn";
import { fn_self_delivery_request, delivery_connect_request, delivery_connect_list } from "../http/DetailConn";
import { analyticeEvent } from "utils/Utils";
import { recent_addr } from "http/dlvCommonConn";

/**
 * 배달관련 함수
 */

// 선택 픽업시간 view설정
export function fn_change_pickup_list(rootStore, time) {
  const deliveryStore = rootStore.deliveryStore;
  deliveryStore.setChangePickView(time);
  deliveryStore.setDeliveryDetailTime(time);
}

// 배달요청
export function fn_recent_addr(rootStore) {
  //최근주소조회(멀티포스)
  recent_addr(rootStore);
}

// 배달요청
export function fn_devliery_request(rootStore) {
  analyticeEvent("riderCallDone", "riderCallSubmitAgency Button", rootStore.searchStore.getShopCd); //GA4
  let checkTime = true;
  let timeValue =
    rootStore.deliveryStore.getExtDetail.delivery_time == null
      ? rootStore.settingStore.getPickupDfTime
      : rootStore.deliveryStore.getExtDetail.delivery_time;

  if (timeValue == null || timeValue == "") {
    checkTime = false;
  }

  if (checkTime) {
    fn_change_pickup_list(rootStore, timeValue);
    select_access_token(rootStore).then(res => {
      let dlv = rootStore.deliveryStore.getExtDetail;
      if (dlv.type === "TPAY") {
        fn_tpay_request(rootStore);
      }
    });
  } else {
    rootStore.layerStore.setLayerAlertType("delivery_time_choice");
    rootStore.layerStore.setLayerAlertView(true);
  }
}

export function fn_dlv_research(rootStore, dlv) {
  select_access_token(rootStore).then(res => {
    rootStore.deliveryStore.setChangeDelivery(dlv.delivery_code);
    rootStore.deliveryStore.setDxtDetail(dlv);
    if (dlv.type === "TPAY") {
      fn_search_tpay_fee(rootStore, true).then(res => {
        if (res === "1") {
        } else {
          fn_deliveryFeeFail(rootStore);
        }
      });
    }
  });
}

// 화면 전체 갱신
export function fn_dlv_reload(rootStore) {
  select_access_token(rootStore).then(res => {
    let dlv = rootStore.deliveryStore.getExtDetail;
    rootStore.deliveryStore.setDxtDetail(dlv);
    if (dlv.type === "TPAY") {
      fn_search_tpay_fee(rootStore, true).then(res => {
        if (res === "1") {
        } else {
          fn_deliveryFeeFail(rootStore);
        }
      });
    }
  });
}

export function fn_dlv_partner_prev(rootStore) {
  rootStore.deliveryStore.setChangeShowDeliveryPrev();
}

export function fn_dlv_partner_next(rootStore) {
  rootStore.deliveryStore.setChangeShowDeliveryNext();
}

// 자체 배달 시작
export function fn_self_devliery_send(rootStore) {
  analyticeEvent("riderCallDone", "riderCallSubmitSelf Button", rootStore.searchStore.getShopCd); //GA4
  rootStore.layerStore.setLayerDeliveryCall(false);
  rootStore.deliveryStore.initDeliveryListFee();

  select_access_token(rootStore).then(res => {
    fn_self_delivery_request(rootStore);
    rootStore.layerStore.setLayerCheckDeposit(false);
  });
}

//연동가능 배달 대행사 연동하기 목록
export function fn_devliery_connect_list(rootStore) {
  //rootStore.layerStore.setLayerDlvConnectView(true);
  rootStore.layerStore.setLayerDlvConnectPop(true);
  delivery_connect_list(rootStore);
}

//배달대행사 목록 조회
export function fn_dlv_connect_pop(rootStore) {
  delivery_connect_list(rootStore);
  rootStore.layerStore.setLayerDlvConnectPop(true);
}

// 배달 대행사 연동하기
export async function fn_devliery_connect_send(rootStore, val) {
  rootStore.settingStore.setDlvRegistInfo("businessNumber", val);
  await delivery_connect_request(rootStore);
}

// 배달 대행사 추가 reset
export function fn_devliery_connect_add_reset(rootStore) {
  //rootStore.settingStore.setDlvConnectResult("")
  rootStore.settingStore.setDlvRegistInfo("businessNumber", "");
  rootStore.settingStore.setDlvRegistInfo("autoMappingYn", "");
  rootStore.settingStore.setDlvRegistInfo("deliveryCode", "");
  rootStore.settingStore.setDlvRegistInfo("subDeliveryCode", "");
  rootStore.settingStore.setDlvRegistInfo("parentDeliveryServiceName", "");
  rootStore.settingStore.setDlvRegistInfo("deliveryServiceName", "");
  rootStore.settingStore.setDlvRegistInfo("agencyCode", "");
  rootStore.settingStore.setDlvRegistInfo("shopName", "");
  document.getElementById("RegistNum").value = "";
}

// 배달 대행사연동하기 추가 pop
export function fn_devliery_connect_add_pop(rootStore, item) {
  rootStore.layerStore.setDlvConnectAdd(true);
  rootStore.settingStore.setDlvRegistInfo("autoMappingYn", item.autoMappingYn);
  rootStore.settingStore.setDlvRegistInfo("deliveryCode", item.deliveryCode);
  rootStore.settingStore.setDlvRegistInfo("subDeliveryCode", item.subDeliveryCode);
  rootStore.settingStore.setDlvRegistInfo("deliveryServiceName", item.deliveryServiceName);
  rootStore.settingStore.setDlvRegistInfo("parentDeliveryServiceName", item.parentDeliveryServiceName);
}

// 배달앱 연동 설정 초기화
export function fn_connectDlvAppInit(rootStore) {
  rootStore.layerStore.setLayerBizNo(false);
  rootStore.layerStore.setLayerPhoneNo(false);
  rootStore.settingStore.setShopBizNo("");
  rootStore.layerStore.setMappingAction(true);
  rootStore.layerStore.setDlvConnectTypeView("");
  const registNumDlv = document.getElementById("RegistNumDlv");
  const bmPhoneNum = document.getElementById("bmPhoneNum");
  const setTime = document.getElementById("setTime");

  if (registNumDlv) {
    registNumDlv.value = "";
  }
  if (bmPhoneNum) {
    bmPhoneNum.value = "";
  }
  if (setTime) {
    setTime.value = "";
  }
  rootStore.layerStore.setLayerLoadingView(false);
}

// 배달대행사 연동하기 선택
export function fn_dlvConnectCodeList(rootStore, item) {
  rootStore.deliveryStore.setDlvConnectCode(item);
}
